import * as React from 'react';

export const usePlainTextContent = (sourceRef: React.RefObject<HTMLElement>, fallback?: string) => {
  return React.useCallback(() => {
    const containerText = sourceRef.current?.innerText?.trim();

    if (containerText) {
      return containerText;
    }

    return fallback?.replace(/\r\n/g, '\n').trim() ?? '';
  }, [fallback, sourceRef]);
};
